module.exports = __webpack_public_path__ + "static/tv-screen-frame-8cfa01d82de3c340ea2154196053d4e0.png";